// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b2022abe","453":"bfd56f49","958":"882d2f8f"}[chunkId] + ".chunk.js";
};